function getUrlPrefix(teamId: string) {
  return `/stores/${teamId}`;
}

export function getBaseSettingsLink(teamId: string) {
  return `${getUrlPrefix(teamId)}/settings`;
}

export enum BillingTab {
  GENERAL = "general",
  RETURNS_AGENT_BILLING = "returns-agent-billing",
  RETURNS = "returns",
  SUPPORT = "support",
  ORDER_TRACKING = "order-tracking",
  MARKETING_EMAIL_SMS = "marketing-email-sms",
  OUTBOUND_LABELS = "outbound",
  CHECKOUT_OPTIMIZATION = "checkout-optimization",
  RECOMMERCE = "recommerce",
  AEO = "aeo",
  IMS = "ims",
  INVOICES = "invoices",
  REPORTS = "reports",
}
export const CURRENT_BILLING_TAB_QUERY = "currentTab";

export function getBillingPageLink(teamId: string, tab: BillingTab): string {
  return `${getBaseSettingsLink(teamId)}/billing/${tab}`;
}

export enum TryFirstTab {
  GENERAL = "general",
  DISPLAY = "display",
  INFO_MODAL = "info-modal",
}
export const CURRENT_TRY_FIRST_TAB_QUERY = "currentTab";

export function getTryFirstPageLink(teamId: string, tab: BillingTab): string {
  return `${getBaseSettingsLink(teamId)}/billing?${CURRENT_BILLING_TAB_QUERY}=${tab}`;
}

export enum CartOptimizationTab {
  SHIPPING_REWARDS = "shipping-rewards",
  CART_TOTALS = "cart-totals",
}
export const CURRENT_CART_OPTIMIZATION_TAB_QUERY = "currentTab";

export function getCustomerSatisfactionPageLink(teamId: string): string {
  return `${getBaseSettingsLink(teamId)}/customer-satisfaction`;
}

export function getBaseSupportLink(teamId: string) {
  return `${getUrlPrefix(teamId)}/support/table/all`;
}

export function getSingleConversationLink(
  teamId: string,
  conversationId: string,
) {
  return `${getBaseSupportLink(teamId)}?activeConversationId=${conversationId}`;
}
